import * as React from 'react';
import { SVGProps } from 'react';

const SvgWarningFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" role="img" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.94 5.125c-.863-1.5-3.017-1.5-3.88 0l-7.757 13.5C1.441 20.125 2.52 22 4.243 22h15.514c1.724 0 2.802-1.875 1.94-3.375l-7.758-13.5Zm-2.846 9.636a.848.848 0 0 0 1.688.016l.559-5.272a1.362 1.362 0 1 0-2.71-.024l.463 5.28Zm.812 2.631a1.304 1.304 0 1 0 0 2.608h.038a1.304 1.304 0 0 0 0-2.608h-.038Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgWarningFilled;
